export interface DashboardProduct {
  id: string;
  name: string;
  category: string;
  samplePrice: number;
  bulkPrice: number;
  moq: number;
  image: string;
  status: "active" | "pending" | "paused";
  views: number;
  orders: number;
}

export interface OrderRequest {
  id: string;
  buyerName: string;
  buyerCountry: string;
  product: string;
  type: "sample" | "bulk";
  qty: number;
  unitPrice: number;
  total: number;
  status: "new" | "confirmed" | "shipped" | "completed" | "cancelled";
  date: string;
  avatar: string;
}

export interface DropshipPartner {
  id: string;
  name: string;
  platform: string;
  country: string;
  sales: number;
  commission: number;
  status: "active" | "pending";
  avatar: string;
}

export const dashboardProducts: DashboardProduct[] = [
  {
    id: "dp1",
    name: "Industrial LED Smart Panel 200W",
    category: "Electronics",
    samplePrice: 120,
    bulkPrice: 45,
    moq: 50,
    image: "https://public.readdy.ai/ai/img_res/6471452d655c35e3c34c389f179a27d7.jpg",
    status: "active",
    views: 1842,
    orders: 34,
  },
  {
    id: "dp2",
    name: "Luxury Arabic Oud Perfume 100ml",
    category: "Fragrance",
    samplePrice: 80,
    bulkPrice: 25,
    moq: 24,
    image: "https://readdy.ai/api/search-image?query=luxury%20Arabic%20oud%20perfume%20bottle%20100ml%20gold%20elegant%20design%20white%20background%20product%20photography%20premium%20fragrance&width=200&height=200&seq=dash2&orientation=squarish",
    status: "active",
    views: 3210,
    orders: 87,
  },
  {
    id: "dp3",
    name: "Smart Home Security Camera 4K",
    category: "Electronics",
    samplePrice: 95,
    bulkPrice: 35,
    moq: 10,
    image: "https://readdy.ai/api/search-image?query=smart%20home%20security%20camera%204K%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20tech&width=200&height=200&seq=dash3&orientation=squarish",
    status: "active",
    views: 2654,
    orders: 61,
  },
  {
    id: "dp4",
    name: "22K Gold Arabic Bangle Set",
    category: "Jewellery",
    samplePrice: 850,
    bulkPrice: 620,
    moq: 5,
    image: "https://readdy.ai/api/search-image?query=22K%20gold%20Arabic%20bangle%20set%20luxury%20jewellery%20white%20background%20product%20photography%20premium%20elegant%20Middle%20East&width=200&height=200&seq=dash4&orientation=squarish",
    status: "pending",
    views: 980,
    orders: 12,
  },
  {
    id: "dp5",
    name: "Premium Medjool Dates Gift Box 1kg",
    category: "Food",
    samplePrice: 65,
    bulkPrice: 22,
    moq: 20,
    image: "https://readdy.ai/api/search-image?query=premium%20Medjool%20dates%20gift%20box%201kg%20luxury%20gold%20packaging%20Saudi%20Arabia%20white%20background%20product%20photography&width=200&height=200&seq=dash5&orientation=squarish",
    status: "active",
    views: 1540,
    orders: 45,
  },
  {
    id: "dp6",
    name: "Wireless Bluetooth Earbuds Pro",
    category: "Electronics",
    samplePrice: 55,
    bulkPrice: 18,
    moq: 30,
    image: "https://readdy.ai/api/search-image?query=wireless%20bluetooth%20earbuds%20pro%20modern%20sleek%20design%20white%20background%20product%20photography%20professional%20audio%20tech&width=200&height=200&seq=dash6&orientation=squarish",
    status: "paused",
    views: 720,
    orders: 8,
  },
];

export const orderRequests: OrderRequest[] = [
  {
    id: "or1",
    buyerName: "James Mitchell",
    buyerCountry: "United Kingdom",
    product: "Industrial LED Smart Panel 200W",
    type: "bulk",
    qty: 200,
    unitPrice: 45,
    total: 9000,
    status: "new",
    date: "2026-04-13",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20business%20person%20portrait%20headshot%20clean%20white%20background%20corporate%20UK%20buyer&width=60&height=60&seq=av1&orientation=squarish",
  },
  {
    id: "or2",
    buyerName: "Yuki Tanaka",
    buyerCountry: "Japan",
    product: "Luxury Arabic Oud Perfume 100ml",
    type: "bulk",
    qty: 500,
    unitPrice: 25,
    total: 12500,
    status: "confirmed",
    date: "2026-04-12",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20business%20person%20portrait%20headshot%20clean%20white%20background%20corporate%20Japan%20buyer&width=60&height=60&seq=av2&orientation=squarish",
  },
  {
    id: "or3",
    buyerName: "Carlos Mendez",
    buyerCountry: "USA",
    product: "Smart Home Security Camera 4K",
    type: "sample",
    qty: 5,
    unitPrice: 95,
    total: 475,
    status: "shipped",
    date: "2026-04-11",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20business%20person%20portrait%20headshot%20clean%20white%20background%20corporate%20USA%20buyer&width=60&height=60&seq=av3&orientation=squarish",
  },
  {
    id: "or4",
    buyerName: "Amara Osei",
    buyerCountry: "Ghana",
    product: "Premium Medjool Dates Gift Box 1kg",
    type: "bulk",
    qty: 300,
    unitPrice: 22,
    total: 6600,
    status: "completed",
    date: "2026-04-10",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20business%20person%20portrait%20headshot%20clean%20white%20background%20corporate%20Africa%20buyer&width=60&height=60&seq=av4&orientation=squarish",
  },
  {
    id: "or5",
    buyerName: "Lars Eriksson",
    buyerCountry: "Sweden",
    product: "Wireless Bluetooth Earbuds Pro",
    type: "sample",
    qty: 3,
    unitPrice: 55,
    total: 165,
    status: "new",
    date: "2026-04-13",
    avatar: "https://readdy.ai/api/search-image?query=professional%20male%20business%20person%20portrait%20headshot%20clean%20white%20background%20corporate%20Sweden%20buyer&width=60&height=60&seq=av5&orientation=squarish",
  },
  {
    id: "or6",
    buyerName: "Priya Sharma",
    buyerCountry: "India",
    product: "22K Gold Arabic Bangle Set",
    type: "bulk",
    qty: 20,
    unitPrice: 620,
    total: 12400,
    status: "confirmed",
    date: "2026-04-09",
    avatar: "https://readdy.ai/api/search-image?query=professional%20female%20business%20person%20portrait%20headshot%20clean%20white%20background%20corporate%20India%20buyer&width=60&height=60&seq=av6&orientation=squarish",
  },
];

export const dropshipPartners: DropshipPartner[] = [
  {
    id: "dsp1",
    name: "TechReview_UK",
    platform: "YouTube",
    country: "United Kingdom",
    sales: 142,
    commission: 2840,
    status: "active",
    avatar: "https://readdy.ai/api/search-image?query=YouTube%20influencer%20tech%20reviewer%20professional%20portrait%20clean%20background%20modern&width=60&height=60&seq=dsp1&orientation=squarish",
  },
  {
    id: "dsp2",
    name: "@luxe_drops",
    platform: "TikTok",
    country: "USA",
    sales: 89,
    commission: 1780,
    status: "active",
    avatar: "https://readdy.ai/api/search-image?query=TikTok%20influencer%20lifestyle%20fashion%20portrait%20clean%20background%20modern%20young&width=60&height=60&seq=dsp2&orientation=squarish",
  },
  {
    id: "dsp3",
    name: "GulfTradersHub",
    platform: "Facebook",
    country: "UAE",
    sales: 210,
    commission: 4200,
    status: "active",
    avatar: "https://readdy.ai/api/search-image?query=Facebook%20business%20page%20trader%20Middle%20East%20professional%20portrait%20clean%20background&width=60&height=60&seq=dsp3&orientation=squarish",
  },
  {
    id: "dsp4",
    name: "ArabicLuxury",
    platform: "Instagram",
    country: "Saudi Arabia",
    sales: 67,
    commission: 1340,
    status: "pending",
    avatar: "https://readdy.ai/api/search-image?query=Instagram%20influencer%20luxury%20lifestyle%20Arabic%20portrait%20clean%20background%20modern&width=60&height=60&seq=dsp4&orientation=squarish",
  },
];
